"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SARA = void 0;
exports.SARA = {
    AG: {
        paintLaborRate: 25.91,
        stripRefitLaborRate: 25.91,
        repairLaborRate: 25.91,
        regionCode: 'AG',
    },
    AL: {
        paintLaborRate: 36.54,
        stripRefitLaborRate: 36.54,
        repairLaborRate: 36.54,
        regionCode: 'AL',
    },
    AN: {
        paintLaborRate: 40.93,
        stripRefitLaborRate: 40.93,
        repairLaborRate: 40.93,
        regionCode: 'AN',
    },
    AO: {
        paintLaborRate: 39.7,
        stripRefitLaborRate: 39.7,
        repairLaborRate: 39.7,
        regionCode: 'AO',
    },
    AP: {
        paintLaborRate: 35.39,
        stripRefitLaborRate: 35.39,
        repairLaborRate: 35.39,
        regionCode: 'AP',
    },
    AQ: {
        paintLaborRate: 33.72,
        stripRefitLaborRate: 33.72,
        repairLaborRate: 33.72,
        regionCode: 'AQ',
    },
    AR: {
        paintLaborRate: 34.5,
        stripRefitLaborRate: 34.5,
        repairLaborRate: 34.5,
        regionCode: 'AR',
    },
    AT: {
        paintLaborRate: 38.29,
        stripRefitLaborRate: 38.29,
        repairLaborRate: 38.29,
        regionCode: 'AT',
    },
    AV: {
        paintLaborRate: 23.7,
        stripRefitLaborRate: 23.7,
        repairLaborRate: 23.7,
        regionCode: 'AV',
    },
    BA: {
        paintLaborRate: 27.05,
        stripRefitLaborRate: 27.05,
        repairLaborRate: 27.05,
        regionCode: 'BA',
    },
    BG: {
        paintLaborRate: 36.92,
        stripRefitLaborRate: 36.92,
        repairLaborRate: 36.92,
        regionCode: 'BG',
    },
    BI: {
        paintLaborRate: 39.14,
        stripRefitLaborRate: 39.14,
        repairLaborRate: 39.14,
        regionCode: 'BI',
    },
    BL: {
        paintLaborRate: 43.02,
        stripRefitLaborRate: 43.02,
        repairLaborRate: 43.02,
        regionCode: 'BL',
    },
    BN: {
        paintLaborRate: 26.94,
        stripRefitLaborRate: 26.94,
        repairLaborRate: 26.94,
        regionCode: 'BN',
    },
    BO: {
        paintLaborRate: 42.18,
        stripRefitLaborRate: 42.18,
        repairLaborRate: 42.18,
        regionCode: 'BO',
    },
    BR: {
        paintLaborRate: 27.68,
        stripRefitLaborRate: 27.68,
        repairLaborRate: 27.68,
        regionCode: 'BR',
    },
    BS: {
        paintLaborRate: 39.48,
        stripRefitLaborRate: 39.48,
        repairLaborRate: 39.48,
        regionCode: 'BS',
    },
    BT: {
        paintLaborRate: 26.46,
        stripRefitLaborRate: 26.46,
        repairLaborRate: 26.46,
        regionCode: 'BT',
    },
    BZ: {
        paintLaborRate: 44.58,
        stripRefitLaborRate: 44.58,
        repairLaborRate: 44.58,
        regionCode: 'BZ',
    },
    CA: {
        paintLaborRate: 37.08,
        stripRefitLaborRate: 37.08,
        repairLaborRate: 37.08,
        regionCode: 'CA',
    },
    CB: {
        paintLaborRate: 26.29,
        stripRefitLaborRate: 26.29,
        repairLaborRate: 26.29,
        regionCode: 'CB',
    },
    CE: {
        paintLaborRate: 24.71,
        stripRefitLaborRate: 24.71,
        repairLaborRate: 24.71,
        regionCode: 'CE',
    },
    CH: {
        paintLaborRate: 31.44,
        stripRefitLaborRate: 31.44,
        repairLaborRate: 31.44,
        regionCode: 'CH',
    },
    CL: {
        paintLaborRate: 26.97,
        stripRefitLaborRate: 26.97,
        repairLaborRate: 26.97,
        regionCode: 'CL',
    },
    CN: {
        paintLaborRate: 38.94,
        stripRefitLaborRate: 38.94,
        repairLaborRate: 38.94,
        regionCode: 'CN',
    },
    CO: {
        paintLaborRate: 45.94,
        stripRefitLaborRate: 45.94,
        repairLaborRate: 45.94,
        regionCode: 'CO',
    },
    CR: {
        paintLaborRate: 37.94,
        stripRefitLaborRate: 37.94,
        repairLaborRate: 37.94,
        regionCode: 'CR',
    },
    CS: {
        paintLaborRate: 28.05,
        stripRefitLaborRate: 28.05,
        repairLaborRate: 28.05,
        regionCode: 'CS',
    },
    CT: {
        paintLaborRate: 26.48,
        stripRefitLaborRate: 26.48,
        repairLaborRate: 26.48,
        regionCode: 'CT',
    },
    CZ: {
        paintLaborRate: 27.1,
        stripRefitLaborRate: 27.1,
        repairLaborRate: 27.1,
        regionCode: 'CZ',
    },
    EN: {
        paintLaborRate: 26.13,
        stripRefitLaborRate: 26.13,
        repairLaborRate: 26.13,
        regionCode: 'EN',
    },
    FC: {
        paintLaborRate: 38.54,
        stripRefitLaborRate: 38.54,
        repairLaborRate: 38.54,
        regionCode: 'FC',
    },
    FE: {
        paintLaborRate: 40.29,
        stripRefitLaborRate: 40.29,
        repairLaborRate: 40.29,
        regionCode: 'FE',
    },
    FG: {
        paintLaborRate: 26.29,
        stripRefitLaborRate: 26.29,
        repairLaborRate: 26.29,
        regionCode: 'FG',
    },
    FI: {
        paintLaborRate: 42.01,
        stripRefitLaborRate: 42.01,
        repairLaborRate: 42.01,
        regionCode: 'FI',
    },
    FM: {
        paintLaborRate: 35.55,
        stripRefitLaborRate: 35.55,
        repairLaborRate: 35.55,
        regionCode: 'FM',
    },
    FR: {
        paintLaborRate: 31.49,
        stripRefitLaborRate: 31.49,
        repairLaborRate: 31.49,
        regionCode: 'FR',
    },
    GE: {
        paintLaborRate: 42.99,
        stripRefitLaborRate: 42.99,
        repairLaborRate: 42.99,
        regionCode: 'GE',
    },
    GO: {
        paintLaborRate: 37.03,
        stripRefitLaborRate: 37.03,
        repairLaborRate: 37.03,
        regionCode: 'GO',
    },
    GR: {
        paintLaborRate: 44.15,
        stripRefitLaborRate: 44.15,
        repairLaborRate: 44.15,
        regionCode: 'GR',
    },
    IM: {
        paintLaborRate: 40.39,
        stripRefitLaborRate: 40.39,
        repairLaborRate: 40.39,
        regionCode: 'IM',
    },
    IS: {
        paintLaborRate: 25.67,
        stripRefitLaborRate: 25.67,
        repairLaborRate: 25.67,
        regionCode: 'IS',
    },
    KR: {
        paintLaborRate: 28.32,
        stripRefitLaborRate: 28.32,
        repairLaborRate: 28.32,
        regionCode: 'KR',
    },
    LC: {
        paintLaborRate: 43.15,
        stripRefitLaborRate: 43.15,
        repairLaborRate: 43.15,
        regionCode: 'LC',
    },
    LE: {
        paintLaborRate: 29.42,
        stripRefitLaborRate: 29.42,
        repairLaborRate: 29.42,
        regionCode: 'LE',
    },
    LI: {
        paintLaborRate: 41.51,
        stripRefitLaborRate: 41.51,
        repairLaborRate: 41.51,
        regionCode: 'LI',
    },
    LO: {
        paintLaborRate: 39.8,
        stripRefitLaborRate: 39.8,
        repairLaborRate: 39.8,
        regionCode: 'LO',
    },
    LT: {
        paintLaborRate: 35.75,
        stripRefitLaborRate: 35.75,
        repairLaborRate: 35.75,
        regionCode: 'LT',
    },
    LU: {
        paintLaborRate: 40.37,
        stripRefitLaborRate: 40.37,
        repairLaborRate: 40.37,
        regionCode: 'LU',
    },
    MB: {
        paintLaborRate: 40.93,
        stripRefitLaborRate: 40.93,
        repairLaborRate: 40.93,
        regionCode: 'MB',
    },
    MC: {
        paintLaborRate: 36.3,
        stripRefitLaborRate: 36.3,
        repairLaborRate: 36.3,
        regionCode: 'MC',
    },
    ME: {
        paintLaborRate: 28.26,
        stripRefitLaborRate: 28.26,
        repairLaborRate: 28.26,
        regionCode: 'ME',
    },
    MI: {
        paintLaborRate: 37.29,
        stripRefitLaborRate: 37.29,
        repairLaborRate: 37.29,
        regionCode: 'MI',
    },
    MN: {
        paintLaborRate: 42.34,
        stripRefitLaborRate: 42.34,
        repairLaborRate: 42.34,
        regionCode: 'MN',
    },
    MO: {
        paintLaborRate: 39.53,
        stripRefitLaborRate: 39.53,
        repairLaborRate: 39.53,
        regionCode: 'MO',
    },
    MS: {
        paintLaborRate: 36.6,
        stripRefitLaborRate: 36.6,
        repairLaborRate: 36.6,
        regionCode: 'MS',
    },
    MT: {
        paintLaborRate: 27.77,
        stripRefitLaborRate: 27.77,
        repairLaborRate: 27.77,
        regionCode: 'MT',
    },
    nan: {
        paintLaborRate: 24.42,
        stripRefitLaborRate: 24.42,
        repairLaborRate: 24.42,
        regionCode: 'nan',
    },
    NO: {
        paintLaborRate: 39.59,
        stripRefitLaborRate: 39.59,
        repairLaborRate: 39.59,
        regionCode: 'NO',
    },
    NU: {
        paintLaborRate: 35.79,
        stripRefitLaborRate: 35.79,
        repairLaborRate: 35.79,
        regionCode: 'NU',
    },
    OR: {
        paintLaborRate: 33.11,
        stripRefitLaborRate: 33.11,
        repairLaborRate: 33.11,
        regionCode: 'OR',
    },
    PA: {
        paintLaborRate: 26.7,
        stripRefitLaborRate: 26.7,
        repairLaborRate: 26.7,
        regionCode: 'PA',
    },
    PC: {
        paintLaborRate: 36.39,
        stripRefitLaborRate: 36.39,
        repairLaborRate: 36.39,
        regionCode: 'PC',
    },
    PD: {
        paintLaborRate: 42.18,
        stripRefitLaborRate: 42.18,
        repairLaborRate: 42.18,
        regionCode: 'PD',
    },
    PE: {
        paintLaborRate: 33.06,
        stripRefitLaborRate: 33.06,
        repairLaborRate: 33.06,
        regionCode: 'PE',
    },
    PG: {
        paintLaborRate: 38.59,
        stripRefitLaborRate: 38.59,
        repairLaborRate: 38.59,
        regionCode: 'PG',
    },
    PI: {
        paintLaborRate: 42.83,
        stripRefitLaborRate: 42.83,
        repairLaborRate: 42.83,
        regionCode: 'PI',
    },
    PN: {
        paintLaborRate: 41.63,
        stripRefitLaborRate: 41.63,
        repairLaborRate: 41.63,
        regionCode: 'PN',
    },
    PO: {
        paintLaborRate: 42.07,
        stripRefitLaborRate: 42.07,
        repairLaborRate: 42.07,
        regionCode: 'PO',
    },
    PR: {
        paintLaborRate: 39.35,
        stripRefitLaborRate: 39.35,
        repairLaborRate: 39.35,
        regionCode: 'PR',
    },
    PT: {
        paintLaborRate: 42.69,
        stripRefitLaborRate: 42.69,
        repairLaborRate: 42.69,
        regionCode: 'PT',
    },
    PU: {
        paintLaborRate: 40.74,
        stripRefitLaborRate: 40.74,
        repairLaborRate: 40.74,
        regionCode: 'PU',
    },
    PV: {
        paintLaborRate: 37.84,
        stripRefitLaborRate: 37.84,
        repairLaborRate: 37.84,
        regionCode: 'PV',
    },
    PZ: {
        paintLaborRate: 28.51,
        stripRefitLaborRate: 28.51,
        repairLaborRate: 28.51,
        regionCode: 'PZ',
    },
    RA: {
        paintLaborRate: 42.74,
        stripRefitLaborRate: 42.74,
        repairLaborRate: 42.74,
        regionCode: 'RA',
    },
    RC: {
        paintLaborRate: 28.45,
        stripRefitLaborRate: 28.45,
        repairLaborRate: 28.45,
        regionCode: 'RC',
    },
    RE: {
        paintLaborRate: 40.67,
        stripRefitLaborRate: 40.67,
        repairLaborRate: 40.67,
        regionCode: 'RE',
    },
    RG: {
        paintLaborRate: 28.5,
        stripRefitLaborRate: 28.5,
        repairLaborRate: 28.5,
        regionCode: 'RG',
    },
    RI: {
        paintLaborRate: 39.7,
        stripRefitLaborRate: 39.7,
        repairLaborRate: 39.7,
        regionCode: 'RI',
    },
    RM: {
        paintLaborRate: 38.32,
        stripRefitLaborRate: 38.32,
        repairLaborRate: 38.32,
        regionCode: 'RM',
    },
    RN: {
        paintLaborRate: 42.18,
        stripRefitLaborRate: 42.18,
        repairLaborRate: 42.18,
        regionCode: 'RN',
    },
    RO: {
        paintLaborRate: 39.21,
        stripRefitLaborRate: 39.21,
        repairLaborRate: 39.21,
        regionCode: 'RO',
    },
    SA: {
        paintLaborRate: 26.27,
        stripRefitLaborRate: 26.27,
        repairLaborRate: 26.27,
        regionCode: 'SA',
    },
    SI: {
        paintLaborRate: 38.48,
        stripRefitLaborRate: 38.48,
        repairLaborRate: 38.48,
        regionCode: 'SI',
    },
    SO: {
        paintLaborRate: 42.06,
        stripRefitLaborRate: 42.06,
        repairLaborRate: 42.06,
        regionCode: 'SO',
    },
    SP: {
        paintLaborRate: 45.37,
        stripRefitLaborRate: 45.37,
        repairLaborRate: 45.37,
        regionCode: 'SP',
    },
    SR: {
        paintLaborRate: 27.45,
        stripRefitLaborRate: 27.45,
        repairLaborRate: 27.45,
        regionCode: 'SR',
    },
    SS: {
        paintLaborRate: 36.39,
        stripRefitLaborRate: 36.39,
        repairLaborRate: 36.39,
        regionCode: 'SS',
    },
    SU: {
        paintLaborRate: 39.2,
        stripRefitLaborRate: 39.2,
        repairLaborRate: 39.2,
        regionCode: 'SU',
    },
    SV: {
        paintLaborRate: 37.47,
        stripRefitLaborRate: 37.47,
        repairLaborRate: 37.47,
        regionCode: 'SV',
    },
    TA: {
        paintLaborRate: 27.57,
        stripRefitLaborRate: 27.57,
        repairLaborRate: 27.57,
        regionCode: 'TA',
    },
    TE: {
        paintLaborRate: 37.25,
        stripRefitLaborRate: 37.25,
        repairLaborRate: 37.25,
        regionCode: 'TE',
    },
    TN: {
        paintLaborRate: 42.96,
        stripRefitLaborRate: 42.96,
        repairLaborRate: 42.96,
        regionCode: 'TN',
    },
    TO: {
        paintLaborRate: 39.61,
        stripRefitLaborRate: 39.61,
        repairLaborRate: 39.61,
        regionCode: 'TO',
    },
    TP: {
        paintLaborRate: 26.32,
        stripRefitLaborRate: 26.32,
        repairLaborRate: 26.32,
        regionCode: 'TP',
    },
    TR: {
        paintLaborRate: 36.39,
        stripRefitLaborRate: 36.39,
        repairLaborRate: 36.39,
        regionCode: 'TR',
    },
    TS: {
        paintLaborRate: 42.48,
        stripRefitLaborRate: 42.48,
        repairLaborRate: 42.48,
        regionCode: 'TS',
    },
    TV: {
        paintLaborRate: 43.63,
        stripRefitLaborRate: 43.63,
        repairLaborRate: 43.63,
        regionCode: 'TV',
    },
    UD: {
        paintLaborRate: 42.53,
        stripRefitLaborRate: 42.53,
        repairLaborRate: 42.53,
        regionCode: 'UD',
    },
    VA: {
        paintLaborRate: 40.6,
        stripRefitLaborRate: 40.6,
        repairLaborRate: 40.6,
        regionCode: 'VA',
    },
    VB: {
        paintLaborRate: 39.89,
        stripRefitLaborRate: 39.89,
        repairLaborRate: 39.89,
        regionCode: 'VB',
    },
    VC: {
        paintLaborRate: 35.76,
        stripRefitLaborRate: 35.76,
        repairLaborRate: 35.76,
        regionCode: 'VC',
    },
    VE: {
        paintLaborRate: 43.17,
        stripRefitLaborRate: 43.17,
        repairLaborRate: 43.17,
        regionCode: 'VE',
    },
    VI: {
        paintLaborRate: 44.04,
        stripRefitLaborRate: 44.04,
        repairLaborRate: 44.04,
        regionCode: 'VI',
    },
    VR: {
        paintLaborRate: 40.5,
        stripRefitLaborRate: 40.5,
        repairLaborRate: 40.5,
        regionCode: 'VR',
    },
    VT: {
        paintLaborRate: 34.08,
        stripRefitLaborRate: 34.08,
        repairLaborRate: 34.08,
        regionCode: 'VT',
    },
    VV: {
        paintLaborRate: 28.8,
        stripRefitLaborRate: 28.8,
        repairLaborRate: 28.8,
        regionCode: 'VV',
    },
};
//# sourceMappingURL=sara.js.map